import {
  Order,
  RfqOrder,
} from '@paradigm/features/src/unified-rfqs/entities/drfq/orders';

// Returns a function that sorts order list putting executed order on top
export function getOrderExecutedBySorterFn(executedOrderId: Order['id']) {
  const toSortedByExecuted = (a: RfqOrder, b: RfqOrder) => {
    if (a.id === executedOrderId) return -1;
    if (b.id === executedOrderId) return 1;

    return 0;
  };

  return toSortedByExecuted;
}
